// Availability gate for the Sole Proprietorship (SPIF / 1040C) option.
//
// Re-enabled 2026-08-08: igdb_mf_data_dump_3_26 is live on ReportData
// (511,104 rows, base+segment+rollup NAICS codes for year 2025) and
// MFController/IFController have the 3_26 year-window branches (both dev
// and prod engine branches). New profiles/reports can select the SP option
// again everywhere it was hidden:
//   - classic selector  Profiles/_partials/ProfileSteps.vue  (serves both the
//     IF Profile and Financial Report flows via NewProfile.vue)
//   - beta selectors    Profiles/SelectorBeta/SelectorPage.vue + ReportPage.vue
//   - report-type card  Reports/CreateReportFormat.vue ("Includes" bullet)
export const SP_SELECTOR_ENABLED = true;
